var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloudArrowUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.75 60.125H20.8125C16.5193 60.125 12.402 58.4195 9.36621 55.3838C6.33046 52.348 4.625 48.2307 4.625 43.9375C4.625 39.6443 6.33046 35.527 9.36621 32.4912C12.402 29.4555 16.5193 27.75 20.8125 27.75C22.1668 27.7495 23.5162 27.9145 24.8305 28.2414",
    stroke: "#2C3B60",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.125 37C23.125 33.3358 23.9957 29.7241 25.6654 26.4624C27.3351 23.2007 29.756 20.3825 32.7286 18.24C35.7011 16.0975 39.1403 14.6921 42.7626 14.1395C46.3848 13.5869 50.0866 13.903 53.5628 15.0617C57.0389 16.2204 60.19 18.1886 62.7563 20.8041C65.3225 23.4195 67.2306 26.6073 68.3231 30.1049C69.4157 33.6024 69.6615 37.3095 69.0402 40.9207C68.419 44.5318 66.9485 47.9436 64.75 50.875",
    stroke: "#2C3B60",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1382 46.7992L43.9374 37L53.7366 46.7992",
    stroke: "#2C3B60",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9375 60.125V37",
    stroke: "#2C3B60",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudArrowUp);
export default __webpack_public_path__ + "static/media/CloudArrowUp.64144bbb958c86a879debd0a08e7a201.svg";
export { ForwardRef as ReactComponent };